module.exports = __webpack_public_path__ + "img/ic_apple_white@2x.1471503.png";